import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { appVariables } from '../app.constants';

@Injectable()
export class XContentTypeOptionsInterceptor implements HttpInterceptor {

  public constructor() {
  }

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const xContentTypeOptions = req.headers.get('X-Content-Type-Options');
    // let clonedRequest: HttpRequest<any>;

    // Clone the request and set the new header.
    if (xContentTypeOptions) {
      req = req.clone({headers: req.headers.set('X-Content-Type-Options', xContentTypeOptions)});
      // clonedRequest = req.clone({
      //   setHeaders: {client_id: clientId, client_secret: clientSecret, 'X-Content-Type-Options': xContentTypeOptions}
      // });
    } else {
      req = req.clone({headers: req.headers.set('X-Content-Type-Options', appVariables.defaultxContentTypeOptionsHeader)});
    }

    // send cloned request with header to the next handler.
    return next.handle(req);
  }
}
